import type { SalesTitleSelection } from "./SalesTitleSwitcher";

export function salesListFilterFromSelection(selection: SalesTitleSelection): {
    filterTitleId?: number;
    filterSalesScope?: "term";
} {
    if (selection === "forfait") return { filterSalesScope: "term" };
    if (typeof selection === "number") return { filterTitleId: selection };
    return {};
}
